import React from "react";

export const Login = React.lazy(() => import('./Login'));
